import React from "react";
import {FaDatabase, FaGamepad, FaLaptopCode, FaReact} from "react-icons/fa";
import "../styles/AboutCards.css";

const AboutCards = () => {
    const cards = [
        {
            icon: <FaReact size={50} />,
            title: "Fullstack\nDeveloper",
            description:
                "Comfortable working with React, Node.js, MongoDB, MySQL, JavaScript, PHP, and HTML/CSS to build web applications and projects.\nPassionate about clean, user-friendly interfaces.",
        },
        {
            icon: <FaLaptopCode size={50} />,
            title: "Software\nDevelopment",
            description:
                "Enjoy creating programs and tools using Python, C#, Java, and Go.\nI enjoy experimenting and learning new things in software development.",
        },
        {
            icon: <FaGamepad size={50} />,
            title: "Game Development",
            description:
                "Basic experience with Unity and C#, mainly for small projects and learning how to design simple game mechanics."
        },
        {
            icon: <FaDatabase size={50} />,
            title: "Backend & Database Design",
            description:
                "Familiar with creating and connecting databases like MongoDB and MySQL to web applications or programs, and writing basic APIs using Node.js and PHP."
        }
    ];

    return (
        <div className="aboutcards-wrapper">
            <div className="cards-container gap-3 gap-md-0 justify-content-center">
                {cards.map((card, index) => (
                    <div key={index} className="card">
                        <div className="d-flex align-items-center mb-3">
                            <div className="icon">{card.icon}</div>
                            <h2 className="ms-4" dangerouslySetInnerHTML={{ __html: card.title.replace(/\n/g, "<br/>") }} />
                        </div>
                        <h3 className="mb-4" dangerouslySetInnerHTML={{ __html: card.description.replace(/\n/g, "<br/>") }} />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default AboutCards;
